import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Development"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 7.5V1.5H7.5V7.5H1.5ZM6 3V6H3V3H6ZM18 9V13.5H13.5V18H9V24H24V9H18ZM15 15H18V18H15V15ZM10.5 22.5H13.5V19.5H10.5V22.5ZM18 22.5H15V19.5H18V22.5ZM19.5 22.5H22.5V19.5H19.5V22.5ZM22.5 18H19.5V15H22.5V18ZM19.5 10.5V13.5H22.5V10.5H19.5ZM13.5 5.25V8.25H10.5V5.25H13.5ZM9 9.75V3.75H15V9.75H9ZM6 12V15H3V12H6ZM1.5 16.5V10.5H7.5V16.5H1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Development.vue"]]);
